import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Combines class names using clsx and merges Tailwind classes using tailwind-merge
 * This is the standard utility function used by shadcn-vue components
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
